const _ = require('lodash');
const moment = require('moment');

const campaignStatus = {
  LIVE: 'live',
  FUTURE: 'future',
  INVALID: 'invlaid',
  COMPLETED: 'completed',
};

const getCampaignStatus = campaign => {
  const liveDate = _.get(campaign, 'liveDate', null);
  const endDate = _.get(campaign, 'endDate', null);

  const hasMissingDates = _.isNil(liveDate) || _.isNil(endDate);

  const startMoment = moment(liveDate);
  const endMoment = moment(endDate);
  const today = moment();

  const hasStarted = startMoment.isValid() ? today.isSameOrAfter(startMoment) : false;
  const hasEnded = endMoment.isValid() ? endMoment.isBefore(today) : false;

  if (hasMissingDates) {
    return campaignStatus.INVALID;
  }
  if (!hasStarted) { // NOT STARTED YET
    return campaignStatus.FUTURE;
  }

  if (hasStarted && !hasEnded) { // is live
    return campaignStatus.LIVE;
  }
  if (hasEnded) {
    return campaignStatus.COMPLETED;
  }
  return campaignStatus.INVALID;
};

module.exports = {
  campaignStatus,
  getCampaignStatus,
};



/** WEBPACK FOOTER **
 ** ./src/utils/campaign-status.js
 **/